import { RouteConfig } from '/@/modules/core/app/helpers/RouteConfig';

export class PlatformReferralRouteConfig extends RouteConfig {}
